"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var clsx_1 = require("clsx");
var react_1 = require("react");
var Price_1 = require("../../../../../common/components/prices/price/Price");
var financeQuotePricesStyles_1 = require("./financeQuotePricesStyles");
var PriceDisplayType_1 = require("../../../../../../../../common/enum/PriceDisplayType");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var FinanceQuotePricesSingleCurrency = function (_a) {
    var labelBefore = _a.labelBefore, labelAfter = _a.labelAfter, primaryPrice = _a.primaryPrice, dataTest = _a.dataTest, variant = _a.variant, className = _a.className, taxLabel = _a.taxLabel;
    var style = financeQuotePricesStyles_1.default();
    var showMonthlyLabel = core_1.useTheme().checkoutLite.enquiryForm.showMonthlyLabel;
    return (<core_1.Box className={style.financeQuoteMultiWrapper} component="span" data-test="summary:container:finance_quote_prices">
      {labelBefore}
      <core_1.Box className={style.prices} component="span">
        <Price_1.default price={primaryPrice.value} priceDisplayType={PriceDisplayType_1.PriceDisplayType.FINANCE} currency={primaryPrice.currency} variant={variant} className={clsx_1.default([style.priceElement, className])} dataTest={dataTest}/>
      </core_1.Box>
      {labelAfter}
      {taxLabel && (<core_1.Typography className={clsx_1.default(style.taxLabelElement)} component="span" data-test="summary:container:finance_quote_taxLabel">
          {taxLabel}
        </core_1.Typography>)}
      {showMonthlyLabel && <Translation_1.default id="trans__configurator__price_with_finance__monthly_label"/>}
    </core_1.Box>);
};
exports.default = FinanceQuotePricesSingleCurrency;
